import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CustomerTestimonials = ({ testimonials }) => {
  return (
    <div className="w-full">
      <div className="text-center mb-8 md:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
          What Our Customers Say
        </h2>
        <p className="text-muted-foreground text-sm md:text-base lg:text-lg max-w-2xl mx-auto">
          Real experiences from our valued customers across Juba
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {testimonials?.map((testimonial) => (
          <div
            key={testimonial?.id}
            className="bg-card rounded-lg p-4 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-border"
          >
            <div className="flex items-center gap-3 md:gap-4 mb-4">
              <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden flex-shrink-0 border-2 border-primary">
                <Image
                  src={testimonial?.customerImage}
                  alt={testimonial?.customerImageAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-foreground font-bold text-sm md:text-base">{testimonial?.name}</h3>
                <p className="text-muted-foreground text-xs md:text-sm">{testimonial?.location}</p>
                <div className="flex items-center gap-1 mt-1">
                  {[...Array(5)]?.map((_, index) => (
                    <Icon
                      key={index}
                      name="Star"
                      size={14}
                      color={index < testimonial?.rating ? 'var(--color-warning)' : 'var(--color-muted)'}
                      className={index < testimonial?.rating ? 'fill-current' : ''}
                    />
                  ))}
                </div>
              </div>
            </div>

            <p className="text-foreground text-sm md:text-base mb-4 line-clamp-4">
              "{testimonial?.review}"
            </p>

            {testimonial?.foodImage && (
              <div className="aspect-[16/9] rounded-lg overflow-hidden mb-3">
                <Image
                  src={testimonial?.foodImage}
                  alt={testimonial?.foodImageAlt}
                  className="w-full h-full object-cover"
                />
              </div>
            )}

            <div className="flex items-center justify-between text-xs md:text-sm text-muted-foreground">
              <span>{testimonial?.date}</span>
              <div className="flex items-center gap-1">
                <Icon name="CheckCircle2" size={14} className="text-accent" />
                <span>Verified Customer</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerTestimonials;